var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1104",
    "data-name": "Rectangle 1104",
    width: 34.466,
    height: 34.263,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_food",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(336.6 222.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217-2",
    "data-name": "Group 217",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21907",
    "data-name": "Path 21907",
    d: "M23.877,15.049l-1.823-.488a2.2,2.2,0,1,0-3.387-1.854,2.167,2.167,0,0,0,.259,1.013L12.87,12.1a.629.629,0,0,0-.772.772l1.622,6.056a2.167,2.167,0,0,0-1.013-.259,2.2,2.2,0,1,0,1.851,3.387l.49,1.823a11.416,11.416,0,1,1,9.08-11.169,11.335,11.335,0,0,1-.251,2.341",
    transform: "translate(1.981 1.981)",
    fill: "#fcd576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21908",
    "data-name": "Path 21908",
    d: "M13.925,27.355a13.433,13.433,0,1,1,13.12-10.565l-1.033-.277a12.395,12.395,0,1,0-9.5,9.5l.277,1.033a13.425,13.425,0,0,1-2.864.31",
    transform: "translate(0.763 0.763)",
    fill: "#deae7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21909",
    "data-name": "Path 21909",
    d: "M8.716,11.642a1.808,1.808,0,0,0,.4-.168,1.9,1.9,0,0,0,.894-1.165,1.923,1.923,0,0,0-.19-1.457,2.03,2.03,0,0,0-.34-.419l8.2,2.2a11.434,11.434,0,0,1-7.287,7.29Z",
    transform: "translate(13.415 12.979)",
    fill: "#fcd576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21910",
    "data-name": "Path 21910",
    d: "M9.752,18.387l-.277-1.033A12.4,12.4,0,0,0,17.433,9.4l1.033.277a13.459,13.459,0,0,1-8.714,8.714",
    transform: "translate(14.583 14.461)",
    fill: "#deae7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21911",
    "data-name": "Path 21911",
    d: "M18.668,12.708a2.167,2.167,0,0,0,.259,1.013L12.869,12.1a.629.629,0,0,0-.769.772l1.622,6.056a2.177,2.177,0,0,0-1.016-.259,2.2,2.2,0,1,0,1.854,3.387l.488,1.823a11.451,11.451,0,1,1,8.831-8.828l-1.826-.488a2.2,2.2,0,1,0-3.385-1.854m2.247,6.724a1.911,1.911,0,0,1-.363,3.042,1.936,1.936,0,0,1-.4.168l1.683,6.279a11.443,11.443,0,0,0,7.29-7.29Z",
    transform: "translate(1.982 1.981)",
    fill: "#fcd576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21912",
    "data-name": "Path 21912",
    d: "M13.952,21.213c-.109,0-.216-.013-.325-.018a2.141,2.141,0,0,1-.919.208,2.18,2.18,0,0,1-1.394-.51A11.392,11.392,0,0,1,5.289,2.373a11.408,11.408,0,0,0,7.419,20.084,11.509,11.509,0,0,0,2.341-.249l-.279-1.041c-.272.023-.543.046-.818.046",
    transform: "translate(1.981 3.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21913",
    "data-name": "Path 21913",
    d: "M11.644,15.468,9.97,9.219a1.9,1.9,0,0,1-.851,1.046,1.808,1.808,0,0,1-.4.168L10.4,16.712a11.407,11.407,0,0,0,5.106-3.425,11.385,11.385,0,0,1-3.862,2.181",
    transform: "translate(13.415 14.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21914",
    "data-name": "Path 21914",
    d: "M9.325,3.906a2.2,2.2,0,1,0-2.2,2.2,2.207,2.207,0,0,0,2.2-2.2m-3.778,0A1.574,1.574,0,1,1,7.121,5.48,1.576,1.576,0,0,1,5.547,3.906",
    transform: "translate(7.568 2.619)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21915",
    "data-name": "Path 21915",
    d: "M6.11,7.121a2.2,2.2,0,1,0-2.2,2.2,2.208,2.208,0,0,0,2.2-2.2M3.906,8.7A1.574,1.574,0,1,1,5.48,7.121,1.576,1.576,0,0,1,3.906,8.7",
    transform: "translate(2.62 7.568)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21916",
    "data-name": "Path 21916",
    d: "M5.731,5.029a1.92,1.92,0,1,0,1.92,1.92,1.921,1.921,0,0,0-1.92-1.92m0,3.209a1.29,1.29,0,1,1,1.29-1.29,1.292,1.292,0,0,1-1.29,1.29",
    transform: "translate(5.866 7.74)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21917",
    "data-name": "Path 21917",
    d: "M8.43,4.208A1.92,1.92,0,1,0,7.467,7.79a1.881,1.881,0,0,0,.5-.066A1.92,1.92,0,0,0,8.43,4.208m.157,2.308A1.29,1.29,0,0,1,6.223,6.2a1.291,1.291,0,1,1,2.364.312",
    transform: "translate(8.539 6.078)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21918",
    "data-name": "Path 21918",
    d: "M3.289,7.823a2.2,2.2,0,1,0,3.115,0,2.255,2.255,0,0,0-3.115,0M5.96,10.494a1.574,1.574,0,1,1,0-2.224,1.575,1.575,0,0,1,0,2.224",
    transform: "translate(4.069 11.078)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21919",
    "data-name": "Path 21919",
    d: "M7.836,3.277a2.2,2.2,0,1,0,3.115,0,2.255,2.255,0,0,0-3.115,0m2.671,2.671a1.573,1.573,0,1,1,0-2.227,1.577,1.577,0,0,1,0,2.227",
    transform: "translate(11.068 4.081)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21920",
    "data-name": "Path 21920",
    d: "M4.846,7.037a2.2,2.2,0,0,0,1.559-3.76,2.255,2.255,0,0,0-3.115,0,2.2,2.2,0,0,0,1.556,3.76M3.734,3.721a1.575,1.575,0,1,1,0,2.227,1.569,1.569,0,0,1,0-2.227",
    transform: "translate(4.071 4.081)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21921",
    "data-name": "Path 21921",
    d: "M15.58,15.58l12.525,3.357a.661.661,0,0,0,.48-.063.636.636,0,0,0,.292-.383A14.688,14.688,0,1,0,18.49,28.877a.629.629,0,0,0,.447-.772Zm10.278,1.45-1.823-.488a2.214,2.214,0,1,0-3.128-.838l-6.056-1.625a.633.633,0,0,0-.772.772L15.7,20.907a2.187,2.187,0,0,0-3.22,1.945,2.2,2.2,0,0,0,4.057,1.183l.488,1.823a11.468,11.468,0,1,1,8.828-8.828m-9.872,4.936.264.988a1.564,1.564,0,1,1-.264-.988m5.291-7.277a1.574,1.574,0,1,1,1.676,1.564l-.988-.267a1.574,1.574,0,0,1-.688-1.3M14.689,28.118a13.433,13.433,0,1,1,13.12-10.565l-1.033-.277a12.395,12.395,0,1,0-9.5,9.5l.277,1.033a13.425,13.425,0,0,1-2.864.31",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21922",
    "data-name": "Path 21922",
    d: "M10.028,9.936a2.205,2.205,0,1,0,3.115,0,2.255,2.255,0,0,0-3.115,0M12.7,12.607a1.574,1.574,0,1,1,0-2.224,1.575,1.575,0,0,1,0,2.224",
    transform: "translate(14.441 14.33)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21923",
    "data-name": "Path 21923",
    d: "M22.1,11.309,8.522,7.671a.629.629,0,0,0-.772.772l3.639,13.582a.632.632,0,0,0,.609.465.594.594,0,0,0,.163-.02A14.713,14.713,0,0,0,22.548,12.081a.632.632,0,0,0-.447-.772M9.408,9.761a1.249,1.249,0,0,1,.6.013,1.292,1.292,0,0,1,.312,2.364,1.358,1.358,0,0,1-.251.107Zm.828,3.088a1.859,1.859,0,0,0,.4-.168,1.919,1.919,0,0,0,.7-2.623A1.94,1.94,0,0,0,11,9.639l8.2,2.2a11.432,11.432,0,0,1-7.29,7.29Zm2.2,8.227-.277-1.033a12.4,12.4,0,0,0,7.958-7.958l1.033.277a13.459,13.459,0,0,1-8.714,8.714",
    transform: "translate(11.895 11.773)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21924",
    "data-name": "Path 21924",
    d: "M7.028,16.347a1.578,1.578,0,1,1-1.115-.46,1.577,1.577,0,0,1,1.115.46M5.1,11.687a1.574,1.574,0,1,0-1.574,1.572A1.577,1.577,0,0,0,5.1,11.687m1.93-4.659a1.575,1.575,0,1,0-2.227,0,1.58,1.58,0,0,0,2.227,0M8.595,10.4a1.291,1.291,0,1,0,1.29,1.292A1.291,1.291,0,0,0,8.595,10.4m3.093,7.881a1.573,1.573,0,1,0,1.562,1.676l-.264-.988a1.568,1.568,0,0,0-1.3-.688m8.163-8.163a1.573,1.573,0,0,0-.889,2.872l.99.264a1.569,1.569,0,0,0-.1-3.136m-6.2-2.283a1.293,1.293,0,0,0-1.765.472,1.3,1.3,0,0,0,.472,1.762,1.291,1.291,0,0,0,1.292-2.234M18.571,4.8a1.574,1.574,0,0,0-2.224,2.227A1.574,1.574,0,1,0,18.571,4.8M11.687,5.1a1.573,1.573,0,1,0-1.574-1.572A1.577,1.577,0,0,0,11.687,5.1M24.137,21.709a1.574,1.574,0,1,0,0,2.227,1.56,1.56,0,0,0,0-2.227m-5.231-3.166a1.281,1.281,0,0,0-.6-.01l.665,2.483a1.37,1.37,0,0,0,.251-.109,1.29,1.29,0,0,0-.312-2.364",
    transform: "translate(3.001 3.001)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21925",
    "data-name": "Path 21925",
    d: "M5.971,7.159a1.292,1.292,0,0,1-1.29-1.29,1.255,1.255,0,0,1,.124-.543A1.287,1.287,0,1,0,6.514,7.035a1.255,1.255,0,0,1-.543.124",
    transform: "translate(6.247 8.197)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21926",
    "data-name": "Path 21926",
    d: "M3.975,9.381a1.57,1.57,0,0,1-.262-1.864,1.543,1.543,0,0,0-.361.259A1.574,1.574,0,1,0,5.578,10a1.484,1.484,0,0,0,.262-.361,1.57,1.57,0,0,1-1.864-.262",
    transform: "translate(4.452 11.569)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21927",
    "data-name": "Path 21927",
    d: "M6.739,4.976a1.567,1.567,0,0,0,1.374-.823,1.538,1.538,0,0,1-.752.2A1.576,1.576,0,0,1,5.787,2.78a1.553,1.553,0,0,1,.2-.752,1.568,1.568,0,0,0,.752,2.948",
    transform: "translate(7.949 3.121)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21928",
    "data-name": "Path 21928",
    d: "M5.578,5.457A1.61,1.61,0,0,0,5.84,5.1,1.563,1.563,0,0,1,3.714,2.971a1.557,1.557,0,0,0-.363.259A1.575,1.575,0,0,0,5.578,5.457",
    transform: "translate(4.451 4.572)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21929",
    "data-name": "Path 21929",
    d: "M4.9,7.369a1.538,1.538,0,0,1-.752.2A1.576,1.576,0,0,1,2.572,6a1.538,1.538,0,0,1,.2-.752A1.568,1.568,0,1,0,4.9,7.369",
    transform: "translate(3.001 8.071)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21930",
    "data-name": "Path 21930",
    d: "M7.361,10.785A1.576,1.576,0,0,1,5.787,9.211a1.553,1.553,0,0,1,.2-.752,1.567,1.567,0,1,0,2.12,2.128,1.551,1.551,0,0,1-.746.2",
    transform: "translate(7.949 13.019)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21931",
    "data-name": "Path 21931",
    d: "M10.679,7.559l-.99-.267A1.555,1.555,0,0,1,9.2,5.243a1.567,1.567,0,0,0-.135,2.674l.99.264a1.571,1.571,0,0,0,1.275-.818,1.589,1.589,0,0,1-.653.2",
    transform: "translate(12.899 8.069)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21932",
    "data-name": "Path 21932",
    d: "M10.713,11.494a1.57,1.57,0,0,1-.262-1.864,1.6,1.6,0,0,0-.361.259,1.574,1.574,0,0,0,2.224,2.227,1.484,1.484,0,0,0,.262-.361,1.57,1.57,0,0,1-1.864-.262",
    transform: "translate(14.822 14.821)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21933",
    "data-name": "Path 21933",
    d: "M7.065,5.9a1.29,1.29,0,0,1-.6-.785,1.274,1.274,0,0,1,.081-.871,1.283,1.283,0,0,0-.1,2.278A1.29,1.29,0,0,0,8.2,6.054c.018-.03.03-.066.046-.1A1.283,1.283,0,0,1,7.065,5.9",
    transform: "translate(8.921 6.539)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21934",
    "data-name": "Path 21934",
    d: "M10.386,5.1A1.563,1.563,0,0,1,8.261,2.971a1.437,1.437,0,0,0-.361.262,1.573,1.573,0,0,0,2.224,2.224,1.555,1.555,0,0,0,.262-.361",
    transform: "translate(11.45 4.572)",
    fill: "#ffaba5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21935",
    "data-name": "Path 21935",
    d: "M9.677,10.361,9.2,8.589a1.357,1.357,0,0,0-.208-.079,1.281,1.281,0,0,0-.6-.01l.665,2.483a1.216,1.216,0,0,0,.251-.109A1.269,1.269,0,0,0,9.83,10.3a1.621,1.621,0,0,1-.152.066",
    transform: "translate(12.913 13.034)",
    fill: "#ffaba5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFood);
export default __webpack_public_path__ + "static/media/ic_food.26dcdc8cb998e8957c47a9282425d401.svg";
export { ForwardRef as ReactComponent };